<template>
  <v-sheet class="px-4 py-4 header-container" :style="$route.path === '/' ? 'background-color: transparent' : 'background-color: white'">
    <!-- 디테일 페이지인 경우 뒤로가기 버튼 -->
    <div v-if="isDetailPage" class="back-button-wrapper">
      <v-icon size="28" style="cursor: pointer" @click="backBtnClick()" color="grey darken-4"> mdi-arrow-left </v-icon>
    </div>

    <!-- 메인 페이지인 경우 기본 헤더 요소들 -->
    <template v-else>
      <!-- 언어 선택 컴포넌트 -->
      <div class="language-select-wrapper">
        <LanguageSelectComponentVue />
      </div>

      <!-- 로고 -->
      <div class="logo-wrapper" v-if="!isIndividual">
        <v-img width="156" height="24" style="cursor: pointer" contain :src="require('@/assets/logo/logo-title.png')" @click="link('/')"></v-img>
      </div>

      <!-- 계정 -->
      <div class="account-wrapper">
        <v-icon v-if="!isLoggedIn" size="28" style="cursor: pointer" @click="loginWithQuery()" color="grey darken-4"> mdi-account-circle-outline </v-icon>

        <div v-if="isLoggedIn">
          <v-img class="rounded-circle" style="width: 28px; height: 28px; cursor: pointer" :src="currentUserProfileImage" @click="link('/mypage/setting')"></v-img>
        </div>
      </div>
    </template>

    <!-- 메뉴 -->
    <!-- <v-icon size="32" color="grey darken-4" @click.stop="menuBtnClick()"> {{ isMenu ? "mdi-menu" : "mdi-arrow-left" }} </v-icon> -->

    <!-- 사이드바 -->
    <!-- <v-navigation-drawer v-model="drawer" height="100vh" absolute temporary>
      <v-list nav class="mt-16">
        <v-list-item-group v-model="group">
          <v-list-item>
            <v-list-item-title @click="link('/')">
              <span class="font-weight-medium">{{ $t("sidemenu.main") }}</span>
            </v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-title @click="link('/location')">
              <span class="font-weight-medium">{{ $t("sidemenu.location") }}</span>
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <v-divider class="mt-6 mb-2 mx-2"></v-divider>
      <LanguageSelectComponentVue />
      
      <div :class="['logo', { 'mobile-bottom': $vuetify.breakpoint.mobile }]">
        <v-img class="mt-6 mx-auto" width="55%" src="@/assets/logo/main.svg"></v-img>
        <p class="mt-2 grey--text px-4 text-caption text-center">ver {{ appVer }}</p>
      </div>
    </v-navigation-drawer> -->
  </v-sheet>
</template>
<script>
import LanguageSelectComponentVue from "@/components/LanguageSelectComponent.vue"
import { mapState, mapGetters, mapMutations, mapActions } from "vuex"

import { AppVersion, isMenuPage } from "../../constant"

export default {
  components: {
    LanguageSelectComponentVue,
  },
  data: () => ({
    drawer: false,
    group: null,

    appVer: AppVersion,
    isIndividual: false,
  }),
  computed: {
    ...mapState(["lafia_user"]),
    ...mapGetters(["lafiaUser_profile_img_path", "jwtUserProfileImagePath"]),

    path() {
      return this.$route.path
    },
    isDetailPage() {
      return !isMenuPage(this.$route.path)
    },
    // 로그인 상태 확인 (lafia_user 기반)
    isLoggedIn() {
      return this.lafia_user.is_logined
    },
    // 사용자 프로필 이미지 (lafia_user 기반)
    currentUserProfileImage() {
      return this.jwtUserProfileImagePath || this.lafiaUser_profile_img_path
    },
  },

  methods: {
    ...mapActions(["getPromotionPrice"]),

    link(url) {
      if (this.$route.path != url) {
        this.$router.push(url)
      }
    },
    loginWithQuery() {
      console.log("loginWithQuery", this.$route.query)
      const currentQuery = this.$route.query
      this.$router.push({
        path: "/auth/login",
        query: currentQuery,
      })
    },
    backBtnClick() {
      console.log("history.length", window.history.length)
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.replace("/")
      }
    },
  },

  async mounted() {
    if (this.$route.query.event) {
      const promotionCode = this.$route.query.event
      const res = await this.getPromotionPrice({ promotionCode: promotionCode })
      this.isIndividual = res != null && res.promotionPrice != null && res.promotionPrice.isIndividual
    }
  },
}
</script>
<style scoped>
.v-btn::before {
  background-color: white !important;
}
.logo {
  position: fixed;
  width: 100%;
  bottom: 70px;
}
.mobile-bottom {
  bottom: 120px;
}
.v-navigation-drawer {
  z-index: 9999 !important;
}
.header-container {
  position: relative;
  display: flex;
  align-items: center;
}
.language-select-wrapper {
  position: absolute;
  left: 16px;
  min-width: 28px;
}
.logo-wrapper {
  margin: 0 auto;
  text-align: center;
}
.account-wrapper {
  position: absolute;
  right: 16px;
}
.back-button-wrapper {
  position: absolute;
  left: 16px;
}
</style>
